export default function LoadingScreen({ label = 'Memuat...', compact = false }) {
  return (
    <div
      className={`grid place-items-center content-center gap-4 text-muted ${
        compact ? 'min-h-64' : 'min-h-screen'
      }`}
    >
      <span
        className="size-8 animate-spin rounded-full border-4 border-line border-t-ink"
        aria-hidden="true"
      />
      <p className="m-0 text-sm">{label}</p>
    </div>
  )
}
